import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import EmployeeFormAdminWidgetPage from "./employee-form/EmployeeFormAdminWidgetPage";
import EmployeeListAdminWidgetPage from "./employee-list/EmployeeListAdminWidgetPage";

const EmployeeWidgetsApp = () => {
  return (
    <Routes>
      <Route path="/employelist" element={<EmployeeListAdminWidgetPage />} />
      <Route path="/employeeform" element={<EmployeeFormAdminWidgetPage />} />
      <Route path="*" element={<Navigate to="/employelist" replace />} />
    </Routes>
  );
};

export default EmployeeWidgetsApp;
